import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';
import type { ExpansionAssignmentsResponse } from './types';

const validate = (runId: number, subscriptionId: number) => {
  if (!runId || runId < 1) {
    throw new Error('Valid run ID is required');
  }
  if (!subscriptionId || subscriptionId < 1) {
    throw new Error('Valid subscription ID is required');
  }
};

type RequestParams = {
  runId: number;
  /**
   * Any subscription of the organization — the API authorises the caller against it and scopes
   * every read by organization, never by this id.
   */
  subscriptionId: number;
  /** Omitted reads the newest batch, which is the one the panel polls. */
  assignmentRunId?: number;
};

export const getAssignments = async (
  scope: RequestScope,
  { runId, subscriptionId, assignmentRunId }: RequestParams,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<ExpansionAssignmentsResponse>> => {
  try {
    validate(runId, subscriptionId);

    const result = await scopedChannelApi(scope).get<ExpansionAssignmentsResponse>(`atts/expansion/runs/${runId}/assignments`, {
      ...options,
      headers: {
        'x-astur-subscription-id': subscriptionId.toString(),
      },
      params: {
        assignment_run_id: assignmentRunId,
      },
    });

    return {
      data: result.data,
      status: result.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
